import { render, staticRenderFns } from "./AddNewProducers.vue?vue&type=template&id=1c698c84&scoped=true"
import script from "./AddNewProducers.vue?vue&type=script&lang=js"
export * from "./AddNewProducers.vue?vue&type=script&lang=js"
import style0 from "./AddNewProducers.vue?vue&type=style&index=0&id=1c698c84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c698c84",
  null
  
)

export default component.exports